import { Card } from 'shared/components/ui/Card';
import { Button } from 'shared/components/ui/Button';

interface CreateAnnouncementCardProps {
  text: string;
  onChangeText: (value: string) => void;
  onPublish: () => void;
}

export function CreateAnnouncementCard({ text, onChangeText, onPublish }: CreateAnnouncementCardProps) {
  return (
    <Card>
      <h3 className="font-heading font-semibold text-ink">Publicar aviso oficial</h3>
      <p className="text-sm text-ink-secondary">
        Vai para o mural da unidade com o selo "aviso oficial" — visível a todos os jogadores.
      </p>

      <textarea
        value={text}
        onChange={(event) => onChangeText(event.target.value)}
        placeholder="Ex.: Areia 2 fechada para manutenção na sexta-feira..."
        rows={3}
        className="mt-3 w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-ink outline-none focus:border-primary"
      />

      <Button className="mt-3" onClick={onPublish} disabled={!text.trim()}>
        Publicar aviso
      </Button>
    </Card>
  );
}
